import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import { LazyLoadImage } from "react-lazy-load-image-component";

// import homeBanner from "assets/images/banner/banner_1024.webp";
// import mobileBanner from "assets/images/banner/mobileBanner.webp";
// import tabBanner from "assets/images/banner/tabBanner.webp";

import Button from "component/Button/Button";
import ProductCard from "component/ProductCard/ProductCard";
import useScreenMobile from "hooks/useScreenMobile";

import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";

import "./banner.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useSlideIndex } from "hooks/useSlider";

import img1 from "assets/images/banner/black.webp";
import img2 from "assets/images/banner/silver.webp";
import img3 from "assets/images/banner/gunmetal.webp";
import img4 from "assets/images/banner/copper.webp";

// const homeBanner = "/images/banner/banner.webp";
// const homeBanner2048 = "/images/banner/banner_2048.webp";
// const homeBanner3240 = "/images/banner/banner_3240.webp";
// const mobileBanner = "/images/banner/mobileBanner.webp";

const slides = [
  { id: 1, title: img1 },
  { id: 2, title: img2 },
  { id: 3, title: img3 },
  { id: 4, title: img4 }
];

const Banner = () => {
  const isMobile = useScreenMobile({ size: 678 });
  const swiperRef = useRef(null);
  const mobileSliderNavRef = useRef(null);
  const { slideIndex } = useSlideIndex();

  useEffect(() => {
    setTimeout(() => {
      if (swiperRef.current) {
        swiperRef.current.autoplay.stop();
        swiperRef.current.slideTo(slideIndex, 100, false);
      }
    }, 300);
  }, [slideIndex]);

  useEffect(() => {
    setTimeout(() => {
      if (swiperRef.current) {
        swiperRef.current.autoplay.start();
      }
    }, 1000);
  }, []);

  return (
    <>
      <section className="container banner">
        <div
          className="bannerImage"
          style={{ zIndex: -100, position: "relative" }}
        >
          <svg
            width="248"
            height="202"
            viewBox="0 0 248 202"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="bannerSvg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M204.003 -68.9985L-71 145.683L-27.0473 201.986L174.781 44.4281L173.99 42.8872L178.739 41.3378L180.347 40.0826L179.136 35.3593L185.614 34.4773L184.902 29.0399L192.797 29.5683L193.607 23.0445L200.581 23.1293L202.188 16.8074L209.175 17.5778L210.834 16.2826L210.416 12.5837L215.728 12.4621L218.132 10.5853L219.917 6.79022L221.994 7.57063L247.955 -12.6961L204.003 -68.9985Z"
              fill="#009DC6"
            />
            <path
              d="M46.9298 84.0294L45.3797 85.2396L43.3965 83.9284L40.3918 86.2743L41.2065 88.4977L39.6445 89.7172L36.2586 79.5792L37.9279 78.2759L46.9298 84.0294ZM38.3168 80.5439L39.8543 84.7747L42.0721 83.0433L38.3168 80.5439ZM48.4797 77.6569L47.23 78.4406C45.5615 79.4746 44.0819 79.3247 43.03 77.9774C41.8757 76.4988 42.3155 74.6777 44.1756 73.2255C45.9641 71.8292 47.88 71.8495 49.2358 73.2667L47.7454 74.4303C46.9227 73.6716 46.0935 73.6665 45.1039 74.4391C44.1857 75.1559 43.9221 76.0718 44.4434 76.7396C44.8716 77.2881 45.4885 77.267 46.3261 76.7666L47.5042 76.0387C49.3821 74.8797 50.8524 75.0177 51.9694 76.4485C53.0865 77.8793 52.6203 79.7403 50.8198 81.1459C48.8763 82.6633 46.8729 82.6537 45.4931 81.2552L47.0074 80.0729C47.8394 80.8436 48.7733 80.7861 49.8822 79.9204C50.7765 79.2222 51.0495 78.3182 50.5188 77.6386C50.0813 77.0782 49.4007 77.0914 48.4797 77.6569ZM58.2332 70.0421L56.9835 70.8259C55.315 71.8598 53.8354 71.7099 52.7835 70.3626C51.6292 68.8841 52.069 67.063 53.9291 65.6108C55.7176 64.2144 57.6334 64.2348 58.9893 65.6519L57.4989 66.8155C56.6762 66.0568 55.847 66.0517 54.8574 66.8243C53.9392 67.5411 53.6756 68.4571 54.1969 69.1248C54.6251 69.6733 55.242 69.6522 56.0796 69.1519L57.2577 68.424C59.1356 67.2649 60.6058 67.4029 61.7229 68.8337C62.84 70.2645 62.3738 72.1255 60.5733 73.5311C58.6297 75.0485 56.6264 75.0389 55.2466 73.6404L56.7609 72.4582C57.5929 73.2288 58.5268 73.1714 59.6357 72.3056C60.53 71.6075 60.8029 70.7034 60.2723 70.0238C59.8348 69.4634 59.1542 69.4766 58.2332 70.0421ZM63.9452 57.9636L65.025 59.3468L60.9352 62.5398L62.3595 64.3641L66.1035 61.4411L67.1834 62.8242L63.4394 65.7472L64.9754 67.7146L69.0651 64.5216L70.145 65.9048L64.5767 70.2521L58.3769 62.311L63.9452 57.9636ZM70.5985 52.7692L71.6784 54.1524L67.5886 57.3453L69.0129 59.1697L72.7569 56.2466L73.8367 57.6298L70.0927 60.5528L71.6287 62.5202L75.7185 59.3272L76.7984 60.7103L71.23 65.0576L65.0302 57.1165L70.5985 52.7692ZM76.8823 47.8634L78.337 46.7277L84.5368 54.6688L82.9986 55.8696L74.8191 52.8902L79.3619 58.7089L77.8834 59.8632L71.6836 51.9221L73.5198 50.4885L81.1924 53.384L76.8823 47.8634ZM85.0407 48.0381C83.0765 45.5223 83.2518 42.6986 85.4695 40.9672C87.6873 39.2357 90.4691 39.7507 92.4333 42.2665C94.2951 44.6513 94.0547 47.3914 91.8369 49.1229C89.6191 50.8544 86.9025 50.4228 85.0407 48.0381ZM90.931 43.4395C89.5253 41.639 87.8953 41.2228 86.5122 42.3026C85.1171 43.3918 85.1374 45.0647 86.5431 46.8652C87.837 48.5226 89.3899 48.8647 90.785 47.7755C92.1681 46.6957 92.2249 45.0969 90.931 43.4395ZM95.5427 33.2947L96.9974 32.159L103.197 40.1001L101.659 41.301L93.4795 38.3216L98.0223 44.1403L96.5438 45.2946L90.344 37.3535L92.1802 35.9199L99.8528 38.8154L95.5427 33.2947Z"
              fill="white"
            />
            <path
              d="M36.8807 125.414L34.3449 126.995C31.211 128.971 28.3635 128.62 26.271 125.94C24.073 123.124 24.9361 119.587 28.5397 116.773C32.0082 114.066 35.7121 114.074 38.2908 116.773L34.935 119.393C33.5795 118.168 32.1961 118.16 30.552 119.444C29.0655 120.604 28.6421 122.059 29.4861 123.14C30.1543 123.995 31.0916 123.989 32.3858 123.232L34.7013 121.787C38.3159 119.545 41.1107 119.828 43.3087 122.643C45.4715 125.413 44.5809 129.009 41.0899 131.734C37.3512 134.653 33.4769 134.705 30.8181 131.996L34.2189 129.341C35.6096 130.611 37.1682 130.518 39.0376 129.059C40.5015 127.916 40.9073 126.439 40.0457 125.336C39.3775 124.48 38.315 124.512 36.8807 125.414ZM37.0087 110.488L40.342 107.885L44.7907 113.583L50.7591 108.924L46.3104 103.226L49.6212 100.641L61.332 115.641L58.0212 118.226L53.1857 112.032L47.2172 116.692L52.0528 122.885L48.7195 125.488L37.0087 110.488ZM77.0751 103.35L73.6066 106.058L70.3045 103.778L64.9892 107.928L66.422 111.667L62.931 114.392L56.423 95.3306L60.1842 92.3941L77.0751 103.35ZM61.0304 97.4247L63.7652 104.642L67.4138 101.794L61.0304 97.4247ZM80.4576 92.0813L77.8225 94.1386L82.0074 99.4989L78.6741 102.101L66.9634 87.1014L73.9003 81.6856C76.8957 79.347 80.2542 79.5163 82.3115 82.1514C83.7357 83.9757 83.7723 86.1584 82.5628 88.0452C84.3708 87.2499 85.7624 87.6859 87.535 89.4921L90.7011 92.7116L87.4579 95.2436L84.538 92.3394C83.2374 90.9986 82.0342 90.8504 80.4576 92.0813ZM75.5802 84.9053L72.4947 87.3143L75.6421 91.3458L78.7277 88.9368C80.1241 87.8466 80.3947 86.4753 79.3925 85.1916C78.3902 83.9078 76.9766 83.8151 75.5802 84.9053ZM80.8822 76.2347L84.2155 73.6323L89.5785 80.5016L89.6434 69.3946L93.765 66.1768L93.5211 78.076L105.723 80.9832L101.85 84.0076L92.6481 81.6939L92.7084 84.5106L95.9262 88.6321L92.5929 91.2345L80.8822 76.2347ZM111.04 52.6901L113.484 55.8207L109.34 59.0561L118.606 70.9253L115.318 73.4926L106.051 61.6233L101.885 64.8763L99.4406 61.7457L111.04 52.6901ZM135.971 57.3683L132.502 60.0762L129.2 57.7967L123.885 61.9465L125.318 65.6854L121.827 68.4109L115.319 49.3492L119.08 46.4127L135.971 57.3683ZM119.926 51.4433L122.661 58.6608L126.31 55.8122L119.926 51.4433ZM135.476 33.6118L138.787 31.027L150.498 46.0268L147.029 48.7347L133.026 43.4275L140.903 53.5175L137.57 56.1199L125.859 41.12L129.958 37.9198L142.897 43.1162L135.476 33.6118ZM140.994 29.3038L144.328 26.7014L149.691 33.5707L149.755 22.4637L153.877 19.2459L153.633 31.1451L165.836 34.0523L161.962 37.0767L152.76 34.7629L152.82 37.5796L156.038 41.7012L152.705 44.3036L140.994 29.3038Z"
              fill="#FFFA5F"
            />
          </svg>

          <div className="tagline">
            <div>
              <div>Be</div>
              <span>NeoSapien</span>
            </div>
            Become Superhuman
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              prevEl: ".custom-swiper-button-prev",
              nextEl: ".custom-swiper-button-next"
            }}
            pagination={{ clickable: true }}
            loop
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => {
              const progress = mobileSliderNavRef.current.querySelector("div");
              const totalSlides = swiper.slides.length;
              const currentIndex = swiper.realIndex;
              const progressPercentage =
                ((currentIndex + 1) / totalSlides) * 100;
              progress.style.width = `${progressPercentage}%`;
            }}
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div
                  className="slideContent"
                  style={{ backgroundColor: slide.isVideo && "black" }}
                >
                  <img src={slide.title} alt="slideImage" />
                </div>
              </SwiperSlide>
            ))}
            <div className="custom-swiper-button-prev"></div>
            <div className="custom-swiper-button-next"></div>
          </Swiper>
        </div>
        <div className="bannerContainer" style={{ zIndex: 1000 }}>
          <div className={isMobile ? "bannerContentMobile " : "bannerContent"}>
            <p>
              Your second brain. Neo 1 is your personal AI companion powered by
              Neo OS.
            </p>
            <Button
              title="Order Now"
              onClick={() => {
                logEvent(analytics, "order_now_banner");
                window.location.href = "https://shop.neosapien.xyz";
              }}
              fontsize={isMobile ? "16px" : "20px"}
              padding={isMobile ? "13px 30px" : "15px 20px"}
            />
          </div>

          {!isMobile && <ProductCard />}
        </div>
      </section>

      <div className="mobileSliderNav">
        <span>Next</span>
        <div ref={mobileSliderNavRef} className="progress">
          <div />
        </div>
        <span style={{ flexGrow: 1 }} />
        <div className="mobileSliderNavButtons">
          <button
            onClick={() => {
              if (swiperRef.current) {
                swiperRef.current.slidePrev();
              }
            }}
          >
            <svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7073 20.2926C11.8002 20.3855 11.8739 20.4958 11.9242 20.6172C11.9745 20.7386 12.0004 20.8687 12.0004 21.0001C12.0004 21.1315 11.9745 21.2616 11.9242 21.383C11.8739 21.5044 11.8002 21.6147 11.7073 21.7076C11.6144 21.8005 11.5041 21.8742 11.3827 21.9245C11.2613 21.9747 11.1312 22.0006 10.9998 22.0006C10.8684 22.0006 10.7383 21.9747 10.6169 21.9245C10.4955 21.8742 10.3852 21.8005 10.2923 21.7076L0.29231 11.7076C0.199333 11.6147 0.125575 11.5044 0.0752506 11.383C0.0249263 11.2616 -0.000976562 11.1315 -0.000976562 11.0001C-0.000976562 10.8687 0.0249263 10.7385 0.0752506 10.6171C0.125575 10.4957 0.199333 10.3854 0.29231 10.2926L10.2923 0.292568C10.4799 0.104927 10.7344 -0.000488286 10.9998 -0.000488281C11.2652 -0.000488276 11.5197 0.104927 11.7073 0.292568C11.895 0.480208 12.0004 0.734704 12.0004 1.00007C12.0004 1.26543 11.895 1.51993 11.7073 1.70757L2.41356 11.0001L11.7073 20.2926Z"
                fill="#191919"
              />
            </svg>
          </button>
          <button
            onClick={() => {
              if (swiperRef.current) {
                swiperRef.current.slideNext();
              }
            }}
          >
            <svg
              width="12"
              height="22"
              viewBox="0 0 12 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7076 11.7076L1.70757 21.7076C1.61466 21.8005 1.50436 21.8742 1.38296 21.9245C1.26157 21.9747 1.13146 22.0006 1.00007 22.0006C0.868673 22.0006 0.738564 21.9747 0.617171 21.9245C0.495778 21.8742 0.385477 21.8005 0.292567 21.7076C0.199657 21.6147 0.125957 21.5044 0.0756741 21.383C0.0253914 21.2616 -0.000488281 21.1315 -0.000488281 21.0001C-0.000488281 20.8687 0.0253914 20.7386 0.0756741 20.6172C0.125957 20.4958 0.199657 20.3855 0.292567 20.2926L9.58632 11.0001L0.292567 1.70757C0.104927 1.51993 -0.000488283 1.26543 -0.000488281 1.00007C-0.000488279 0.734704 0.104927 0.480208 0.292567 0.292568C0.480208 0.104927 0.734704 -0.000488279 1.00007 -0.000488281C1.26543 -0.000488283 1.51993 0.104927 1.70757 0.292568L11.7076 10.2926C11.8005 10.3854 11.8743 10.4957 11.9246 10.6171C11.975 10.7385 12.0009 10.8687 12.0009 11.0001C12.0009 11.1315 11.975 11.2616 11.9246 11.383C11.8743 11.5044 11.8005 11.6147 11.7076 11.7076Z"
                fill="#191919"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default Banner;
